/**
 * Validates a Polish NIP (tax identification number).
 *
 * Rules:
 * - Exactly 10 digits (spaces and dashes are stripped before validation)
 * - Checksum: weights [6,5,7,2,3,4,5,6,7] applied to first 9 digits,
 *   remainder mod 11 must equal the 10th digit
 *
 * Returns true if valid, false otherwise.
 */
export function validateNip(value: string): boolean {
  if (!value) return false;
  const cleaned = value.replace(/[\s-]/g, '');
  if (!/^\d{10}$/.test(cleaned)) return false;
  const weights = [6, 5, 7, 2, 3, 4, 5, 6, 7];
  const checksum = weights.reduce((sum, w, i) => sum + w * parseInt(cleaned[i], 10), 0);

  return checksum % 11 === parseInt(cleaned[9], 10);
}
